import find from 'lodash/find';
import startsWith from 'lodash/startsWith';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import { ChevronRight } from 'react-feather';
import Sticky from 'react-stickynode';
import config from '../config';
import { getPageTree } from '../utils/contentful';
import Hero from './Hero';
import styles from './Page.module.scss';

export default class Page extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    imageUrl: PropTypes.string,
    pages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      subpages: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
      })),
    })).isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    imageUrl: undefined,
  };

  state = {
    submenu: [],
  };

  componentWillMount() {
    this.buildSubmenu();
  }

  buildSubmenu() {
    const { pages, location } = this.props;

    const subtree = find(getPageTree(pages).subpages, ({ path }) => startsWith(location.pathname, path));

    if (subtree && subtree.subpages.length) {
      this.setState({ submenu: [subtree, ...subtree.subpages] });
    }
  }

  renderSidebar(submenu) {
    return (
      <aside id="sidebar" className={styles.sidebar}>
        <Sticky top={15} bottomBoundary="#sidebar">
          <h3 className={styles.sidebarTitle}>Explore</h3>
          <ul className={styles.submenu}>
            {submenu.map(({ path, title }) => (
              <li key={path} className={styles.submenuItem}>
                <Link
                  className={styles.submenuLink}
                  activeClassName={styles.submenuLinkActive}
                  to={path}
                  exact
                >
                  {title} <ChevronRight />
                </Link>
              </li>
            ))}
          </ul>
        </Sticky>
      </aside>
    );
  }

  render() {
    const { title, imageUrl, location, children } = this.props;
    const { submenu } = this.state;

    const isIndex = location.pathname === '/';

    // TODO: use template='Content'
    const contactsPath = `/${config.nav.contactsSlug}/`;

    return (
      <div className={styles.root}>

        <Helmet
          defaultTitle={config.siteName}
          titleTemplate={`%s — ${config.siteName}`}
          title={!isIndex ? title : ''}
        />

        <Hero
          title={title}
          imageUrl={imageUrl}
        />

        <div id="body" className={styles.body}>
          <div className={styles.content}>
            {children}
          </div>

          {!!submenu.length && this.renderSidebar(submenu)}
        </div>

        {(location.pathname !== contactsPath) && (
          <div className={styles.banner}>
            <div className={styles.bannerContainer}>
              Got any questions or need a consultation?
              <Link className={styles.bannerLink} to={contactsPath}>Contact Us</Link>
            </div>
          </div>
        )}

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Page.js